/**
 * 文字列操作系の共通クラス
 */
export default {
  /**
   * 全角を全角に変換
   * @param input
   */
  toHalfWidth(input: string): string {
    return input.replace(/[！-～]/g, (_input) =>
      String.fromCharCode(_input.charCodeAt(0) - 0xfee0),
    )
  },

  /**
   * ハイフン込の数字を抽出
   * @param value
   */
  pickNumberHyphen<T>(value: T): string {
    let num = ''
    // 数字のみ抽出
    if (typeof value === 'string') {
      const rep = value.replace(/[^0-9０-９-]/g, '')
      if (rep) {
        num = this.toHalfWidth(rep)
      }
    } else if (typeof value === 'number') {
      num = value.toString()
    }
    return num
  },
  /**
   * メールフォーマットかどうかチェックする
   * @param mail
   */
  checkFormatMail(mail: string): boolean {
    if (!mail) return false
    const reg =
      /^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
    return reg.test(mail)
  },
}
